import { createContext } from 'react';

import { CategoricalBarChartCategoryAxisConfiguration } from '../types/categorical-bar-chart.js';
import { defaultConfig } from '../types/defaults.js';

export const CategoricalBarChartCategoryAxisContext =
  createContext<CategoricalBarChartCategoryAxisConfiguration>(
    defaultConfig.categoryAxis,
  );
